module.exports = __webpack_public_path__ + "img/illu_token_01.43d96ddb.svg";